import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const StarIcon = "/StarIcon.svg";

const TaskCompletion = ({ trigger = false, message = "1 task completed, keep going!" }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        //console.log("TaskCompletion - Trigger value:", trigger); // Debug log
        
        if (trigger) {
            console.log("TaskCompletion - Setting visible to true"); // Debug log
            setVisible(true);
            
            // Increased timeout to match parent component (8000ms)
            const timer = setTimeout(() => {
                // console.log("TaskCompletion - Setting visible to false"); // Debug log
                setVisible(false);
            }, 5000);
            
            return () => {
                // console.log("TaskCompletion - Cleanup triggered"); // Debug log
                clearTimeout(timer);
            };
        }
    }, [trigger]);

    // console.log("TaskCompletion - Current visible state:", visible); // Debug log

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.3 }}
                    className="fixed bottom-[180px] right-3 md:bottom-28 md:right-5 bg-[#18181b] text-white rounded-lg px-3 h-10 z-[9999] flex items-center gap-2 border border-white/10 shadow-lg"
                >
                    <img src={StarIcon} alt="Star Icon" className="w-4 h-4" />
                    <span className="text-sm font-extralight">{message}</span>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default TaskCompletion;
